import * as React from 'react';
import styled from 'styled-components';
import { Input } from '../General/Input';
import { rem } from 'polished';

export interface Props {
  name?: string;
  type?: string;
  placeholder?: string;
  value: string;
  onFocus: any;
  onChange: any;
  isMobile?: boolean;
}

function SearchFormInput(props) {
  return <StyledInput {...props} />;
}

const StyledInput = styled(Input)`
  padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(50)};
  line-height: 1.2857142857;
  border-radius: ${rem(4)} ${rem(0)} ${rem(0)} ${rem(4)};
  max-width: initial;
  box-shadow: none;
  color: ${({ theme }) => theme.colors.black};
  border: ${rem(1)} solid #cccccc;

  &::placeholder {
    color: #888888;
    font-family: 'Roboto', sans-serif;
  }

  ${({ theme }) => theme.media(0, 'sm')} {
    width: 100%;
    padding: ${rem(10)} ${rem(112)} ${rem(11)} ${rem(16)};
    height: ${rem(40)};
    border-radius: ${rem(4)};

    max-width: calc(100% - 32px);
    margin: 0 auto;

    &::placeholder {
      color: transparent;
      opacity: 0;
    }
  }

  ${({ theme }) => theme.media('sm')} {
    font-size: ${rem(14)};
    padding: ${rem(14)} ${rem(16)} ${rem(15)} ${rem(56)};
  }
`;

export { SearchFormInput };
